import { createEffect, createSignal } from "solid-js";
import useUpdatePassword from "../../services/profile/useUpdatePassword";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import { Modal } from "../../components/ui/Modal";
import { DialogFooter } from "@/components/shadcn/dialog";

export default function PasswordModal(props) {

  const [open, setOpen] = createSignal(false);
  const onClose = (state) => {
    if (typeof props.onClose === 'function') {
      props.onClose();
    }
  }

  const { form, fetching, onFormInput, updatePassword, loading } = useUpdatePassword(onClose);

  createEffect(() => {
    props.open;
    setOpen(props.open);
  });

  return (
    <Modal
      open={open()}
      title="Change Password"
      onClose={onClose}
      fetching={fetching()}
      hideOnOutsideClick={false}
      error={''}
    >
      <div class="grid gap-2">
        <div class="grid gap-1">
          <TextInput
            type="password"
            name="oldPassword"
            form={form}
            loading={loading()}
            sr={false}
            input={onFormInput}
            label='Old Password'
            placeholder="" />
        </div>
        <div class="grid gap-1">
          <TextInput
            type="password"
            name="newPassword"
            form={form}
            loading={loading()}
            sr={false}
            input={onFormInput}
            label='New Password'
            placeholder="" />
        </div>
        <div class="grid gap-1">
          <TextInput
            type="password"
            name="confirmPassword"
            form={form}
            loading={loading()}
            sr={false}
            input={onFormInput}
            label='Confirm New Password'
            placeholder="" />
        </div>
      </div>
      <DialogFooter>
				<LoadingButton variant="outline" onClick={() => { updatePassword() }} type="button" disabled={loading()}>Change</LoadingButton>
			</DialogFooter>
    </Modal>
  );
}
